module.exports = "<h3>Welcome!</h3>\n<p>This is the main page.</p>\n<div>\n    <h3>{{clientName}}</h3>\n    <pre>{{selectedClient}}</pre>\n</div>\n<!-- TODO: Remove this following button. -->\n<button class=\"btn btn-primary\" (click)=\"testEnvironmentAvailability()\" type=\"button\">Test Environment Availability</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/components/welcome/welcome.component.html
// module id = ./src/app/home/components/welcome/welcome.component.html
// module chunks = main